import React, { useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SpinnerSuccess = ({ config = {}, closeHandler = () => null, clearHandler = () => null }) => {
  const timerRef = useRef(null)
  const { autoCloseDelaySec, autoClearDelaySec } = config
  useEffect(() => {
    // componentDidMount
    if (autoCloseDelaySec === 0) {
      closeHandler()
    } else if (autoCloseDelaySec) {
      timerRef.current = setTimeout(closeHandler, autoCloseDelaySec * 1000)
    } else if (autoClearDelaySec === 0) {
      clearHandler()
    } else if (autoClearDelaySec) {
      timerRef.current = setTimeout(clearHandler, autoClearDelaySec * 1000)
    }
    return () => {
      // component will unmount
      clearTimeout(timerRef.current)
    }
  }, [])

  const message = config.message
    ? <div className="message">
    {config.message}
  </div>
    : null
  return (
    <div id="spinner-success">
      <div className="wrapper">
        {message}
        <div
          className="success animate__animated animate__rotateIn"
        >
          <FontAwesomeIcon icon={['fas', 'check-circle']} size="1x" />
        </div>
        {config.bottomContent ? config.bottomContent(closeHandler, clearHandler) : null}
      </div>
    </div>
  )
}

export default SpinnerSuccess
